/* unplugin-vue-components disabled */import script from "./banList.vue?vue&type=script&setup=true&lang=js"
export * from "./banList.vue?vue&type=script&setup=true&lang=js"

import "./banList.vue?vue&type=style&index=0&id=b216ef54&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b216ef54"]])

export default __exports__